import React, { useEffect } from 'react';
import Modal from 'react-native-modal';
import { IconSvg } from 'src/assets';
import { useTripDetailQuery } from 'src/common/hooks';
import { Container, EmptyState, IconButton, Row, TripDetailBody } from 'src/components';
import { TicketTab } from 'src/screens/myTicket/components/TicketTab';
import { AppColors } from 'src/themes/Colors';
import { device, metrics } from 'src/themes/Metrics';

export const TripDetailModal = ({
  isVisible,
  onClose,
  returnTripId,
  departureTripId,
}: {
  returnTripId?: string;
  departureTripId?: string;
  isVisible: boolean;
  onClose: () => void;
}) => {
  const [ticketTabbar, setTicketTabbar] = React.useState<number>(0);
  const [tripId, setTripId] = React.useState(departureTripId);
  console.log({ tripId, departureTripId });
  const { data, isFetching, isError, refetch, error } = useTripDetailQuery({ tripId });

  useEffect(() => {
    if (ticketTabbar === 0) setTripId(departureTripId);
    if (ticketTabbar === 1) setTripId(returnTripId);

    refetch();
  }, [ticketTabbar]);

  return (
    <Modal
      style={{ margin: 0, justifyContent: 'flex-end' }}
      animationIn="slideInUp"
      animationOut="slideOutDown"
      onSwipeComplete={onClose}
      onBackButtonPress={onClose}
      onBackdropPress={onClose}
      swipeThreshold={10}
      propagateSwipe
      isVisible={isVisible}
      //   swipeDirection={['down']}
    >
      <Container style={{ height: device.height * 0.9 }} backgroundColor={AppColors.white}>
        <Row width="100%" padding={metrics.medium}>
          <IconButton onPress={onClose} icon={<IconSvg.Close fill={AppColors.black} />} />
        </Row>

        {departureTripId && returnTripId && (
          <Container>
            <TicketTab value={ticketTabbar} onChange={setTicketTabbar} />
          </Container>
        )}
        {isFetching || isError ? (
          <EmptyState loading={isFetching} error={error} text="tripEmptyContent" />
        ) : (
          <TripDetailBody onCloseModal={onClose} tripDetailInfo={data} />
        )}
      </Container>
    </Modal>
  );
};
